import { ChangeDetectorRef, Directive, OnChanges, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs';

@Directive()
export abstract class ICmsUtilSimpleAbstractComponent implements OnInit, OnChanges, OnDestroy {
    /**
     * If componet is past init
     */
    initiated = false;

    /**
     * If asynchronous change detection is allowed
     */
    protected asyncCd = true;

    /**
     * If can detach
     */
    protected canDetach = true;

    /**
     * Subscriptions
     */
    protected readonly subscriptions = new Subscription();

    /**
     * Dependencies
     */
    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        protected timeoutService: TimeoutService
    ) {}

    /**
     * Initialisation hook
     */
    ngOnInit(): void {
        if (this.canDetach) {
            this.changeDetectorRef.detach();
        }
        this.initiated = true;
        if (this.canDetach) {
            this.detectChanges();
        }
    }

    /**
     * Changes hook
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ngOnChanges(changes): void {
        this.detectChanges();
    }

    /**
     * Destroy hook
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Change detection
     */
    detectChanges(): void {
        if (this.initiated) {
            const cd = () => {
                if (!(<ViewRef>this.changeDetectorRef).destroyed) {
                    this.changeDetectorRef.detectChanges();
                }
            };
            if (this.asyncCd) {
                this.timeoutService.async(cd);
            } else {
                cd();
            }
        }
    }

    /**
     * Tracking function
     */
    trackByIndex(index: number): number {
        return index;
    }
}
